import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { comparisonRows } from '../../data/content';
import { SectionLabel } from '../ui/SectionLabel';
export function Comparison() {
  return <section aria-labelledby="comparativa-title" className="w-full bg-ink-850" data-id="element-46" data-mp="30nwma9qfqnp0">
      <div className="mx-auto max-w-5xl px-5 py-16 md:py-20" data-id="element-47" data-mp="2vpbkw6zg5xyz">
        <div className="max-w-3xl" data-id="element-48" data-mp="2votkcy5r4xl9">
          <div className="text-center" data-id="element-49" data-mp="2qq8fumjgvrr0">
            <SectionLabel data-id="element-50" data-mp="2qra09hmdhqle">Dejá de improvisar. Empezá a acompañar con un sistema.</SectionLabel>
          </div>
          <h2 id="comparativa-title" className="mt-5 font-display text-3xl font-black leading-tight text-white md:text-4xl" data-id="element-51" data-mp="2lxytthlh3bu0">
            La misma situación, con y sin el Método
          </h2>
        </div>
        <div className="mt-10 overflow-x-auto rounded-2xl border border-ink-border shadow-panel" data-id="element-52" data-mp="27zr1jmzdsyp6">
          <table className="w-full min-w-[640px] border-collapse text-left" data-id="element-53" data-mp="230nvq0bkuog5">
            <thead data-id="element-54" data-mp="232qvhc2j7vy2">
              <tr className="bg-ink-950" data-id="element-55" data-mp="3kjqhcf6lkvmw">
                <th scope="col" className="px-6 py-4 text-sm font-bold text-white" data-id="element-56" data-mp="3kinq265d4r6g">
                  Situación
                </th>
                <th scope="col" className="px-6 py-4 text-sm font-bold text-subtle" data-id="element-57" data-mp="3pcjmv59w4801">
                  Sin el Método
                </th>
                <th scope="col" className="bg-brand-greenDeep px-6 py-4 text-sm font-bold text-brand-greenSoft" data-id="element-58" data-mp="3ghvfn9kr8g8l">
                  Con el Método ✓
                </th>
              </tr>
            </thead>
            <tbody data-id="element-59" data-mp="c33zxfzznovm">
              {comparisonRows.map(row => <tr key={row.situation} className="border-t border-ink-border bg-ink-card" data-id="element-60" data-mp="3u8gtukz9k205">
                  <th scope="row" className="px-6 py-4 text-[15px] font-semibold text-white" data-id="element-61" data-mp="325waytgpjdk">
                    {row.situation}
                  </th>
                  <td className="px-6 py-4 text-[15px] text-body" data-id="element-62" data-mp="2iwpogasxvmh4">
                    <span className="flex items-start gap-2" data-id="element-63" data-mp="2nv0yomn5byzv">
                      <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-red-400" strokeWidth={3} aria-hidden="true" data-id="element-64" data-mp="23rv4ubkw5hl3" />
                      {row.without}
                    </span>
                  </td>
                  <td className="bg-brand-greenDeep/25 px-6 py-4 text-[15px] text-body" data-id="element-65" data-mp="1q0ghjsjyau88">
                    <span className="flex items-start gap-2" data-id="element-66" data-mp="1l0lslujqkept">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand-green" strokeWidth={3} aria-hidden="true" data-id="element-67" data-mp="1l259nnd7utsn" />
                      {row.with}
                    </span>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </section>;
}